import React from 'react';

import {
  FeedbackContainer,
  FeedbackImage,
  FeedbackTitle,
  FeedbackSubtitle,
  FeedbackRetryText,
  FeedbackButton,
} from '@/components/Template/Feedback';

import processing from '@/assets/processing.svg';

import PaymentLoading from '@/components/Loading';

import useProcessing from './Processing.hook';

const Processing: React.FC = () => {
  const { getLinkIsLoading, showTimer, timerText, handleOpenLink } =
    useProcessing();

  if (getLinkIsLoading) return <PaymentLoading />;

  return (
    <FeedbackContainer>
      <FeedbackImage src={processing} alt="Link em processamento" />
      <FeedbackTitle>Aguardando a autenticação do banco</FeedbackTitle>
      <FeedbackSubtitle>
        Você poderá tentar novamente em instantes.
      </FeedbackSubtitle>

      {!showTimer ? (
        <FeedbackButton onClick={handleOpenLink}>
          Tentar novamente
        </FeedbackButton>
      ) : (
        timerText && (
          <FeedbackRetryText>{`Tentar novamente em ${timerText}`}</FeedbackRetryText>
        )
      )}
    </FeedbackContainer>
  );
};

export default Processing;
